import { scaffolderPlugin } from '@backstage/plugin-scaffolder';
import { createScaffolderFieldExtension } from '@backstage/plugin-scaffolder-react';
import {
  SelectExtension
} from './select';

export const DomainSelectExtension: any = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: 'domainSelectExtension',
    component: SelectExtension,
  }),
  
);
